<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.operate-btns {
  display: flex;
  justify-content: center;
}

.reject-btn.btn {
  background: #FFF2F4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #FB2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;

}

.pass-btn.btn {
  background: #F2FFF5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1BA854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #FF991C;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #F5F5F5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">委托方</div>
          <el-select size="mini" class="ipt-sty" @change="handleChangeCompany" v-model="page.tenantGuid"
            placeholder="请选择委托方" filterable>
            <el-option v-for="(item, index) in sendTenantList" :key="index" :label="item.sendTenantName"
              :value="item.sendTenantGuid"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">执行部门</div>
          <el-select size="mini" class="ipt-sty" v-model="page.organisationInfo" filterable placeholder="请选择执行部门">
            <el-option v-for="(item, index) in organisationList" :key="index" :label="item.organisationName"
              :value="item.guid"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">执行时间</div>
          <el-date-picker size="mini" class="ipt-sty" v-model="timeRange" type="daterange" align="left" unlink-panels
            range-separator="-" start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
          {{ showMore ? '收起筛选' : '更多筛选' }}
        </el-button>
        <el-button size="mini" type="info" @click="search">搜索</el-button>
        <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="mt15" v-show="showMore">
      <!-- <el-col :span="6"
            ><div class="search-area-div">审批状态</div>
            <el-select  size="mini" v-model="page.approvalState" filterable placeholder="请选择执行状态" class="ipt-sty" >
              <el-option v-for="item in approvalStateList" :key="item.value" :label="item.label" :value="item.value"></el-option> </el-select
          ></el-col> -->
        <el-col :span="6">
          <div class="search-area-div">执行状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.timeState" filterable placeholder="请选择执行状态">
            <el-option v-for="item in timeStateList" :key="item" :label="item" :value="item"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">任务包状态</div>
          <el-select size="mini" class="ipt-sty" v-model="page.state" filterable placeholder="请选择任务包状态">
            <el-option v-for="item in stateList" :key="item" :label="item" :value="item"></el-option> </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">提交人</div>
          <el-input type="text" size="mini" class="ipt-sty" placeholder="请输入提交人" v-model="page.submitStaffName"></el-input>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">配置任务包</el-button>
      </div>
      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column fixed="left" label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column fixed="left" prop="taskTitle" width="320" label="任务标题" show-overflow-tooltip
          header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskTitle || '-' }}</template>
        </el-table-column>
        <el-table-column prop="submitStaffName" label="提交人" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.submitStaffName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="审批状态" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.bizApproveVO && scope.row.state == '待发布'">
              <a class="reject-btn btn" v-if="scope.row.bizApproveVO.approveState == 'R'">已驳回</a>
              <a class="pass-btn btn" v-if="scope.row.bizApproveVO.approveState == 'Y'">已通过</a>
              <a class="ing-btn btn" v-if="scope.row.bizApproveVO.approveState == 'A'">审批中</a>
              <a class="cancel-btn btn" v-if="scope.row.bizApproveVO.approveState == 'C'">已撤销</a>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" show-overflow-tooltip width="240" label="委托方" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column prop="serviceTenantName" show-overflow-tooltip width="240" label="服务商" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.serviceTenantName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" width="200" show-overflow-tooltip label="执行部门" header-align="center"
          align="left">
          <template slot-scope="scope">{{ getDepartmentName(scope.row.organisationInfo || scope.row.oldOrganisationInfo)
          }}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" width="210" label="执行时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.startTime | getDate }} 至 {{
            scope.row.endTime | getDate
          }}</template>
        </el-table-column>

        <el-table-column prop="taskDetailCount" width="96" label="任务项目数" header-align="center" align="left">
          <template slot-scope="scope">共{{ scope.row.taskDetailCount }}项目</template>
        </el-table-column>
        <el-table-column prop="state" :render-header="renderHeader" width="96" label="任务包状态" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.state }}</template>
        </el-table-column>

        <el-table-column prop="timeState" width="96" label="业务执行状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.timeState }}</template>
        </el-table-column>
        <!-- <el-table-column prop="createUserName" width="96" label="完成状态" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.finishState }}</template>
          </el-table-column>
          <el-table-column prop="createUserName" width="96" label="成果上传状态" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.uploadState }}</template>
          </el-table-column>
          <el-table-column prop="createUserName" width="96" label="结算状态" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.payState }}</template>
          </el-table-column> -->
        <el-table-column prop="taskNo" width="120" label="任务包编号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskNo }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="180px" label="操作" header-align="center" align="left">
          <template slot-scope="scope">
            <div class="operate-btns">
              <a @click="passDialogVisible = true; detail = scope.row.bizApproveVO; approveSuggest = ''" class="txt-color"
                v-if="scope.row.state == '待发布' && scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.approveStaffGuids && scope.row.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1">通过</a>
              <a class="txt-color"
                @click="rejectDialogVisible = true; detail = scope.row.bizApproveVO; approveSuggest = ''"
                v-if="scope.row.state == '待发布' && scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.approveStaffGuids && scope.row.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1">驳回</a>
              <a class="txt-color" @click=toRevoke(scope.row.bizApproveVO)
                v-if="scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.staffGuid == staffGuid">撤销</a>
              <a class="txt-color"
                v-if="scope.row.state == '待发布' && !scope.row.bizApproveVO && userGuid == scope.row.createUserId"
                @click="reBackVersion(scope.row, 0)">撤回</a>
              <a class="txt-color"
                v-if="(scope.row.state == '已驳回' && userGuid == scope.row.createUserId)||(scope.row.state == '已撤回' && userGuid == scope.row.createUserId) || (scope.row.state == '草稿中' && userGuid == scope.row.createUserId) || (scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'R' && userGuid == scope.row.createUserId) || (scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'C' && userGuid == scope.row.createUserId)"
                @click="delVersion(scope.row.guid)">删除</a>
              <a class="txt-color" v-if="scope.row.state == '草稿中' && userGuid == scope.row.createUserId"
                @click="reBackVersion(scope.row, 1)">继续编辑</a>
              <a class="txt-color" v-if="(scope.row.state == '已撤回'||scope.row.state == '已驳回')&& userGuid == scope.row.createUserId"
                @click="reBackVersion(scope.row, 1)">重新提交</a>
              <!-- 驳回、撤销 -->
              <a class="txt-color"
                v-if="scope.row.state == '待发布' && scope.row.bizApproveVO && scope.row.bizApproveVO.staffGuid == staffGuid && scope.row.bizApproveState != 'D' && (scope.row.bizApproveVO.approveState == 'R' || scope.row.bizApproveVO.approveState == 'C')"
                @click="reBackVersion(scope.row, 1)">重新提交</a>
              <a class="txt-color" @click="see(scope.row)">任务详情</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" maxlength="100" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" maxlength="100" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userGuid: userinfo.userGuid,
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      staffGuid: userinfo.staffGuid,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      textTitle: '配置任务包',
      stateList: ['待发布', '草稿中','已撤回','已驳回'],
      timeStateList: ['未开始', '进行中', '已结束'],
      tenantList: [],
      organisationList: [],
      timeRange: '',
      page: {
        taskBelongCategory:1,
        serviceTenantGuid: localStorage.guid,
        createUserIdFilterDraft: localStorage.userId,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '',
        timeState: '',
        isService: 'Y',
        submitStaffName: '',
        // approvalState:'-1',
      },
      // approvalStateList: [{
      //   label: '全部',
      //   value: '-1'

      // },{
      //   label: '审批中',
      //   value: 'A'

      // }, {
      //   label: '已通过',
      //   value: 'Y'

      // }, {
      //   label: '已驳回',
      //   value: 'R'

      // },
      // {
      //   label: '已撤销',
      //   value: 'C'

      // }],
      right: 'right',
      tableData: [],
      sendTenantList: [],
    };
  },
  created() {
    // notifyType	 1控销   2任务包   notifyPartyGuid staffGuid
    this.page.state = this.$route.query.state;
    this.getTenantList();
    this.getSendTenantList();
    this.getList();
  },
  activated() {
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    getDepartmentName(list) {
      if (typeof list == 'string') {
        list = JSON.parse(list);
      }
      let personArr = [];
      let personTip = '';
      let departmentArr = [];
      let departmentTip = '';
      let personNum = 0;
      let departmentNum = 0;
      if (list && list.length > 0) {
        list.forEach(i => {
          if (i.objectType == '人员') {
            personArr.push(i.organisationName || i.name);
            personNum = personNum + 1;
          } else {
            departmentNum = departmentNum + 1;
            departmentArr.push(i.organisationName || i.name);
          }
        });
      }
      personTip =
        personArr.length > 2
          ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
          : personArr.splice(0, 2).join('、');
      // console.log(personArr);
      departmentTip =
        departmentArr.length > 2
          ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
          : departmentArr.splice(0, 2).join('、');
      return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      if (self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      var req = JSON.parse(JSON.stringify(this.page));
      req.state = req.state ? [req.state] : ['待发布', '草稿中','已撤回','已驳回'];
      // req.approvalState = req.approvalState&& req.approvalState!='-1'?[req.approvalState]:null;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      var req = JSON.parse(JSON.stringify(this.page));
      req.state = req.state ? [req.state] : ['待发布', '草稿中','已撤回','已驳回'];
      // req.approvalState = req.approvalState&& req.approvalState!='-1'?[req.approvalState]:null;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: this.$getValueListByKey('上游客户分类'),
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleChangeCompany(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        }
      });
    },
    addVersion() {
      this.$router.push('/taskDeliverAdd?productGuid='+this.$route.query.productGuid);
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    emptySearch() {
      this.page = {
        taskBelongCategory:1,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '',
        timeState: '',
        serviceTenantGuid: localStorage.guid,
        createUserIdFilterDraft: localStorage.userId,
        isService: 'Y',
        submitStaffName: ''
      };
      this.organisationList = [];
      this.timeRange = '';
      this.getList();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    reBackVersion(detail, type) {
      if (type == 0) {
        //撤回
        this.fullscreenLoading = true;
        var self = this;
        var req = {
          guid: detail.guid,
          state: '已撤回',
          currentTenantGuid:localStorage.guid
        };
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('撤回成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        //重新提交
        this.$router.push('/taskDeliverAdd?guid=' + detail.guid + '&is_edit=1&productGuid='+this.$route.query.productGuid);
      }
    },
    //驳回提交
    toRejectSubmit() {
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.detail.approveGuid,
        flowType: '00012',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let query = {
        guid: this.detail.approveGuid,
        flowType: '00012',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //撤回
    toRevoke(detail) {
      let self = this;
      this.$confirm('撤销后，该流程将不再进行审核，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: detail.approveGuid,
          flowType: '00012',
          approveStaffGuid: this.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('撤销成功！');
            this.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    see(detail) {
      this.$router.push('/taskDeliverAdd?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //查看
    },
    toDeal(detail) {
      this.$router.push('/taskDeliverModify?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //去处理
    },
    toUpload() {
      this.$router.push('/operationReport?productGuid='+this.$route.query.productGuid); //查看
    },
    toPay() {
      this.$router.push('/freeList?productGuid='+this.$route.query.productGuid);
    },
    // toSeeProgress(detail) {
    //   this.$router.push('/taskProgress?guid=' + detail.guid+'&productGuid='+this.$route.query.productGuid); //去处理
    // },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '1、草稿中：任务处于待编辑状态，提交后才能发布；',
                h('br'),
                '2、待发布：需要企业人员确认任务包是否发布；',
                h('br'),
                '3、已撤回：运营人员取消任务包的配置；',
                h('br'),
                '4、已驳回：企业人员驳回待发布的任务包；',
                h('br'),
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
  },
};
</script> 
<style scoped>
.txt-color {
  word-break: keep-all;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
  margin: 0 4px;
}
/* FOUR-2993 复测口径：180 宽度内按钮同行展示（不加宽列，只保单行不折行） */
.content-main-box /deep/ .operate-btns {
  flex-wrap: nowrap;
}
.content-main-box /deep/ .operate-btns a {
  flex-shrink: 0;
  white-space: nowrap;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.search-area-div{
  /* width:86px; */
}
.el-col-6{
  display: flex;
}
 .el-col-8{
  display: flex;
}
</style>